import React from 'react';

const useFoodhubApi = () => {

    const baseURL = 'https://foodhub-api2.herokuapp.com/api/v1/';


    return {
        baseURL
    }
};

export default useFoodhubApi;